import { stationsIdsByBranchSeo } from './regions/msk';

export function determineMetroBranch(selectedStations: number[]): string | null {
    const selectedBranches = new Set<string>();
    let isLength = false;

    for (const [ branch, stations ] of stationsIdsByBranchSeo) {
        const isAllSelected = stations.every(stationId => selectedStations.includes(stationId));

        if (isAllSelected) {
            selectedBranches.add(branch);
            if (stations.length === selectedStations.length) {
                isLength = true;
            }
        }
    }

    if (selectedBranches.size === 1 && isLength) {
        return [ ...selectedBranches ][0];
    }
    return null;
}
